import { useCallback, useMemo } from 'react';
import { useSessionStorage } from 'usehooks-ts';

import { getStartOfDay } from 'utils/date';

export default function useSelectedDate(): [Date, (date: Date) => void] {
  const today = getStartOfDay(new Date()).toISOString();
  const [dateString, setDateString] = useSessionStorage(
    'activityPlanningSelectedDate',
    today
  );

  // The stored string is the source of truth; the Date is derived from it and
  // must keep its identity, or every caller holding it in a dependency array
  // re-runs on each render.
  const date = useMemo(() => new Date(dateString), [dateString]);

  // Only setDateString is used here; keying on dateString would hand out a new
  // setter on every date change, which makes callers' effects fire again.
  const setDate = useCallback(
    (date: Date) => setDateString(date.toISOString()),
    [setDateString]
  );

  return [date, setDate];
}
